
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { BindReportGrid, exportToExcel, OpenBase64Pdf, setFocus, setTitle } from "../Common/Common";
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { getCommonData } from '../Common/CommanServices';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";
import Loader from '../Layout/Loader';

const InHandReport = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode')
    const WarehouseName = cookies.get('warehouseName');
    const WarehouseCode = cookies.get('warehouseCode')
    const [salesPerson, setSalesPerson] = useState([]);
    const [ItemGroup, setItemGroup] = useState([]);
    const [WareHouseData, setWareHouseData] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [ItemNoData, setItemNoData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [exporting, setExporting] = useState(false);
    const [MenuText, setMenuText] = useState("Item Inhand Report");

    const [tableData, setTableData] = useState({})

    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        Item: "",
        ItemGroup: "",
        WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
    });

    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }

    useEffect(() => {
        setTitle('IteminHandReport', setOpen);
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
        setFocus('txtItemGroup');
    }, [isUpdate])

    //useEffect(() => {
    //    getIteminHandData();
    //}, [FilterData.PageIndex, isUpdate]);

    const getIteminHandData = (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExItemInHandReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'InHandReport');

                    }
                }
            }
            else if (res.Status === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData({

                });
            }
            setIsLoading(false)
        })
    }

    const handlePrintData = (ID) => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData,
            Source: "Report",
            Token,
            LoginUserCode: loginCodeString
        };
        setIsLoading(true)
        post(`${API_SERVER}/api/Print/GetItemInHandPrint`, { ...data }, (res) => {
            if (res.message === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.status === 'SUCCESS') {
                console.log(res, "resresres")
                OpenBase64Pdf(res.documentPdfBase64, 'ItemInHandPrint_' + ID, '_blank');
            }
            if (res.status === 'ERROR' || res.message !== '') {
                AlertBox(res.status, res.message, res.focus);
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false)
        });
    }

    const handleChange1 = (event, value) => {
        getIteminHandData("S", value);
    };

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
                Item: "",
                ItemGroup: "",
                WareHouse: WarehouseCode ? WarehouseCode + ' : ' + WarehouseName : "",
            }
        );

        setTableData(
            {
                totalRecord: 0,
                gridData: [{
                }]
            }
        );
        setIsUpdate(!isUpdate)
        setFocus('txtItemGroup');
    }

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getIteminHandData();
    }

    const handleDownloadExcel = async () => {
        setExporting(false);
        await getIteminHandData('E');
        setExporting(false);
    }
    const getWareHouse = () => {
        setWareHouseData([])
        let temp = {
            Type: "GetWareHouse",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let warehouseData = res.autoCompleteData || [];
                setWareHouseData(warehouseData);
            } else {
                console.error("Error fetching WareHouse data:", res.message);
                setWareHouseData([]);
            }
        });
    }
    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };
    const getItemGroup = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetItemGroup",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemGroup = res.autoCompleteData || [];
                setItemGroup(itemGroup);
            } else {
                setItemGroup([]);
            }
        });
    };
    let SalesPersonArr = []
    for (let i = 0; i < salesPerson.length; i++) {
        let mydata = salesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };
    let ItemGroupArr = []
    for (let i = 0; i < ItemGroup.length; i++) {
        let mydata = ItemGroup[i]?.values
        ItemGroupArr.push(mydata)
    };
    let WareHouseArr = []
    for (let i = 0; i < WareHouseData.length; i++) {
        let mydata = WareHouseData[i]?.values
        WareHouseArr.push(mydata)
    };

    const getItemNo = () => {
        setItemNoData([])
        let temp = {
            Type: "GetItemNo",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let itemData = res.autoCompleteData || [];
                setItemNoData(itemData);
            } else {
                setItemNoData([]);
            }
        });
    }
    let ItemNoArr = []
    for (let i = 0; i < ItemNoData.length; i++) {
        let mydata = ItemNoData[i]?.values
        ItemNoArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtWareHouse") };
                                                }}
                                                label='Item Group'
                                                placeholder="Item Group"
                                                maxLength='50'
                                                options={ItemGroupArr}
                                                id='txtItemGroup'
                                                ignore_common={true}
                                                onFocus={() => getItemGroup()}
                                                inputValue={FilterData.ItemGroup ? FilterData.ItemGroup : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('ItemGroup', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                                label='Ware House'
                                                placeholder="Ware House"
                                                maxLength='50'
                                                disabled={WarehouseCode ? true : false}
                                                options={WareHouseArr}
                                                id='txtWareHouse'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getWareHouse()}
                                                inputValue={FilterData.WareHouse ? FilterData.WareHouse : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('WareHouse', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtItemNo") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={FilterData.SalesPerson ? FilterData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">

                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("btnSearch") };
                                                }}
                                                label='Item No'
                                                placeholder="Item No"
                                                maxLength='50'
                                                options={ItemNoArr}
                                                id='txtItemNo'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getItemNo()}
                                                inputValue={FilterData.Item ? FilterData.Item : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('Item', newInputValue)

                                                }}

                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button print-btn" onClick={handlePrintData} >
                                                <i className="bi bi-printer" /> Print
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} exporting={exporting} setExporting={setExporting} currentPageNo={currentPageNo}
                handleChange1={handleChange1} />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default InHandReport